import React, { useState, useEffect } from 'react'
import '../Componenets/Details.css'
import icon from '../images/infoicon.e45f1623.svg'
import nav from '../images/GDSC logo.png'
import { getDatabase, ref, set, onValue } from "firebase/database";
import Swal from 'sweetalert2'
import Alert from 'react-bootstrap/Alert'
import { useUserAuth } from "../context/UserAuthContext";
import { signOut } from "firebase/auth";
import logout from '../images/logout.png'
import { auth } from "../firebase";
import Loader from "../Componenets/Loader"


const data = {
  roles: [
    {
      domain: "Technical Domain",
      subdomain: ["AI & ML Lead", "Android Development Lead", "Cloud Lead", "Web Development Lead", "Competitive Programming Lead"]
    },
    {
      domain: "Non-Technical Domain",
      subdomain: ["Video Editor Lead", "Content Writer Lead", "Public Relations", "Event Management Lead"]
    },
  ]
};

const Details = () => {
  const [formStep, setFormStep] = useState(0);
  const [RollNo, setRollNo] = useState('');
  const [Email, setEmail] = useState('');
  const [FirstName, setFirstName] = useState('');
  const [LastName, setLastName] = useState('');
  const [Branch, setBranch] = useState('');
  const [Year, setYear] = useState('');
  const [Domain, setDomain] = useState('');
  const [subDomain, setSubDomain] = useState('');
  const [Resume, setResume] = useState('');
  const [Github, setGithub] = useState('');
  const [LinkedIn, setLinkedIn] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useUserAuth();
  const formStatus = 1;
  const [mailerState, setMailerState] = useState({
    email: user.email,
    name: FirstName,
  });

  const availableDomain = data.roles.find((c) => c.domain === Domain);

  const completeFormStep = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      setFormStep(formStep + 1);
    }, 3000);
  };
  const completeFormStepPrev = () => {
    setFormStep(formStep - 1);
  };

  const sendEmail = async () => {
    console.log({ mailerState });
    // https://gdsc-recruitment-backend.vercel.app/send
    await fetch("https://gdsc-recruitment-backend.vercel.app/send", {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({ mailerState }),
    })
      .then((res) => res.json())
      .then(async (res) => {
        const resData = await res;
        console.log(resData);
        if (resData.status === "success") {
          // alert("Message Sent");
          console.log(resData.status);
        } else if (resData.status === "fail") {
          // alert("Message failed to send");
        }
      })
      .then(() => {
        setMailerState({
          email: user.email,
          name: FirstName,
        });
      });
  }

  const handleSubmit2 = (e) => {
    e.preventDefault();
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Register!'
    }).then((result) => {
      if (result.isConfirmed) {
        const db = getDatabase();
        set(ref(db, user.uid), {
          VerifyEmail: Email,
          FirstName: FirstName,
          LastName: LastName,
          Branch: Branch,
          Year: Year,
          Role: subDomain,
          Resume: Resume,
          Github: Github,
          LinkedIn: LinkedIn,
          RollNo: RollNo,
          Status: 'UnderReview',
          userid: user.uid,
          Email: user.email
        })

        sendEmail();



        Swal.fire({
          title: 'Congratulations',
          text: "You have successfully registered for GDSC GLAU Hiring process. We will review your application and get back to you very soon. You can also track your application on your Dashboard.",
          icon: 'success',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Go to Dashboard'
        }).then(() => {
          window.location = '/dashboard';
        })
      }
    })
  }
  // check user is in database or not
  const handleSubmit = (e) => {
    e.preventDefault();
    // setIsLoading(false);
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      const db = getDatabase();
      onValue(ref(db, user.uid), (snapshot) => {
        if (snapshot.val() === null) {
          setFormStep(formStep + 1);
        }
        if (snapshot.val().userid === user.uid) {
          Swal.fire({
            title: 'Already Registered!',
            text: "You have already registered for GDSC GLAU 2022",
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Go to Dashboard'
          }).then((result) => {
            if (result.isConfirmed) {
              window.location = '/dashboard';
            } else {
              window.location = '/dashboard';
            }
          }
          )
        }
      }
      )
    }, 3000);
  }


  const handleLogoutConfirm = (e) => {
    e.preventDefault();
    Swal.fire({
      title: 'Are you sure?',
      text: "If you logout, you will loose all your data!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'green',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Logout!'
    }).then((result) => {
      if (result.isConfirmed) {
        handleLogout();
        Swal.fire(
          'Logged Out!',
          'You are logged out successfully!',
          'success'
        )
      }
    }
    )
  }


  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (formStatus === 0) {
      Swal.fire({
        title: 'Error',
        text: "Oops...! Registration is not Started Yet!",
        icon: 'question',
        confirmButtonColor: '#4285F4',
        confirmButtonText: 'Close'
      }).then((result) => {
        if (result.isConfirmed) {
          handleLogout();
          Swal.fire(
            'Logged Out!',
            'You are logged out successfully!',
            'success'
          )
        } else {
          handleLogout();
        }
      }
      )
    } else if (formStatus === 1) {
      Swal.fire({
        title: 'Error',
        text: "Oops...! Registration Are Closed!",
        icon: 'question',
        confirmButtonColor: '#4285F4',
        confirmButtonText: 'Close'
      }).then((result) => {
        if (result.isConfirmed) {
          handleLogout();
        } else {
          handleLogout();
        }
      }
      )
    }
  })


  return (
    <>
      <div className="absolute object-left-top">
        <div className="Header_nav-logo">
          <img src={nav} className="navbar-image" alt="home img" />
          <p className="text">
            Google Developer Student Clubs
            <br />
            GLA University
          </p>
        </div>
      </div>

      <div className='question-image' onClick={handleLogoutConfirm}>
        <img src={logout} alt="question" className='font-gelionMedium' />
      </div>

      <div className="alert">
        <Alert variant="primary">
          <p>
            <img src={icon} alt="icon" className="instruction-img" />
            If you face any problem in filling the form, please contact us at <a href="mailto: gdsc@gla.ac.in" style={{ fontWeight: '500' }}> gdsc@gla.ac.in</a>
          </p>
        </Alert>
      </div>

      {isLoading ? <Loader /> : null}

      {formStep === 0 && (<div className="helper2">
        <p className="helper-text2">
          Confirm your details
        </p>
        <p style={{ color: 'red' }}>All field is required</p>
        <form onSubmit={handleSubmit}>
          <input type="number" placeholder="University roll No." className='Textarea1' value={RollNo} onChange={(e) => setRollNo(e.target.value)} required />
          <input pattern="[a-z0-9._%+-]+@gla\.ac\.in" title="Invalid Mail ID" type="email" value={Email} placeholder="University Email Id" className='Textarea1' style={{ marginTop: '30px' }} onChange={(e) => setEmail(e.target.value)} required />
          <button className="confrim-btn" >
            <span className="font-gelionLight text-xl"> Confirm </span>
          </button>
        </form>
        <div className="instruction-header">
          <img src={icon} alt="icon" className="instruction-img" />
          <h2 className="instruction">Please enter correct University Roll No.</h2>
        </div>
        <div className="instruction-header">
          <img src={icon} alt="icon" className="instruction-img" />
          <h2 className="instruction">We will contact you via your registered Email ID.</h2>
        </div>
        <div className="instruction-header">
          <img src={icon} alt="icon" className="instruction-img" />
          <h2 className="instruction">Do not refresh the page until the registration is complete.</h2>
        </div>
      </div>
      )}

      {formStep === 1 && (<div className="helper2">
        <p className="helper-text2" >
          Personal Information
        </p>
        <p style={{ color: 'red' }}>All field is required</p>
        <form onSubmit={completeFormStep}>
          <input type="text" placeholder="First Name" className='Textarea1' value={FirstName} onChange={(e) => setFirstName(e.target.value)} required />
          <input type="text" placeholder="Last Name" className='Textarea1' value={LastName} onChange={(e) => setLastName(e.target.value)} required />
          <select type="select" value={Branch} className='Textarea1' style={{ width: '100%' }} onChange={(e) => setBranch(e.target.value)} required>
            <option value="">Choose Your Branch</option>
            <option>CSE</option>
            <option>CS - AI&ML</option>
            <option>CS - CCV</option>
            <option>CS - CSF</option>
            <option>CS - DA</option>
            <option>CS - IOT</option>
            <option>Other</option>
          </select>
          <select type="select" value={Year} className='Textarea1' style={{ width: '100%' }} onChange={(e) => setYear(e.target.value)} required>
            <option value="">Choose Your Year</option>
            <option>2nd</option>
            <option>3rd</option>
            <option>4th</option>
          </select>
          <div className="btn" style={{ display: 'flex', flexDirection: 'row', margin: '0 0' }}>
            <button className="confrim-btn2" onClick={completeFormStepPrev}>
              <span className="font-gelionLight text-xl"> Back </span>
            </button>
            <button className="confrim-btn" >
              <span className="font-gelionLight text-xl"> Next </span>
            </button>
          </div>
        </form>
        <div className="instruction-header">
          <img src={icon} alt="icon" className="instruction-img" />
          <h2 className="instruction">Domain selections on the next screen cannot be changed once confirmed.</h2>
        </div>
        <div className="instruction-header">
          <img src={icon} alt="icon" className="instruction-img" />
          <h2 className="instruction">Do not refresh the page until the registration is complete.</h2>
        </div>
      </div>
      )}

      {formStep === 2 && (<div className="helper2">
        <p className="helper-text2" style={{ fontSize: '2.75rem' }}>
          Domain Selection
        </p>
        <p style={{ color: 'red' }}>All field is required</p>
        <form onSubmit={completeFormStep}>
          <select type="select" className='Textarea1' style={{ width: '100%' }} value={Domain} onChange={(e) => setDomain(e.target.value)} required>
            <option value="">Select Domain</option>
            {data.roles.map((value, key) => {
              return (
                <option value={value.domain} key={key}>
                  {value.domain}
                </option>
              );
            })}
          </select>
          <select type="select" className='Textarea1' style={{ width: '100%', marginTop: '30px' }} value={subDomain} onChange={(e) => setSubDomain(e.target.value)} required>
            <option value="">Select Sub Domain</option>
            {availableDomain?.subdomain.map((value, key) => {
              return (
                <option value={value.domain} key={key}>
                  {value}
                </option>
              );
            })}
          </select>
          <div className="btn" style={{ display: 'flex', flexDirection: 'row', margin: '0 0' }}>
            <button className="confrim-btn2" onClick={completeFormStepPrev}>
              <span className="font-gelionLight text-xl"> Back </span>
            </button>
            <button className="confrim-btn">
              <span className="font-gelionLight text-xl"> Next </span>
            </button>
          </div>
        </form>
        <div className="instruction-header">
          <img src={icon} alt="icon" className="instruction-img" />
          <h2 className="instruction">Domain and Sub Domain selection cannot be changed once confirmed.</h2>
        </div>
        <div className="instruction-header">
          <img src={icon} alt="icon" className="instruction-img" />
          <h2 className="instruction">Do not refresh the page until the registration is complete.</h2>
        </div>
      </div>
      )}

      {formStep === 3 && (<div className="helper2">
        <p className="helper-text2">
          Professional Details
        </p>
        <p style={{ color: 'red' }}>All field is required</p>
        <p style={{ color: 'red', fontSize: '16px' }}>Note (URL MUST INCLUDE 'https://')</p>
        <form onSubmit={handleSubmit2}>
          <input type="url" placeholder="GitHub Profile URL (Optional for Non-Tech Domain)" className='Textarea1' value={Github} onChange={(e) => setGithub(e.target.value)} />
          <input type="url" value={LinkedIn} placeholder="Linkedin Profile URL" className='Textarea1' onChange={(e) => setLinkedIn(e.target.value)} required />
          <input type="url" value={Resume} placeholder="Resume URL" className='Textarea1' onChange={(e) => setResume(e.target.value)} required />
          <div className="btn" style={{ display: 'flex', flexDirection: 'row', margin: '0 0' }}>
            <button className="confrim-btn2" onClick={completeFormStepPrev}>
              <span className="font-gelionLight text-xl"> Back </span>
            </button>
            <button className="confrim-btn" >
              <span className="font-gelionLight text-xl"> Submit </span>
            </button>
          </div>
        </form>
        <div className="instruction-header">
          <img src={icon} alt="icon" className="instruction-img" />
          <h2 className="instruction">We contact you via your registered Email ID that you used for sign in not your University Email ID.</h2>
        </div>
        <div className="instruction-header">
          <img src={icon} alt="icon" className="instruction-img" />
          <h2 className="instruction">Do not refresh the page until the registration is complete.</h2>
        </div>
      </div>
      )}
    </>
  )
}

export default Details